import { useState, useEffect } from 'react';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import GlobalModal from 'components/modal/GlobalModal';
import Nav from 'components/nav/Nav';
import MainRouter from 'router/MainRouter';
import { Footer } from 'stories/components/Footer';
import { useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { theme } from 'asserts/styles/theme';
import ScrollToTopButton from 'components/button/ScrollToTopButton';

const App = () => {
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(false);

  const links =
    location.pathname !== '/login' &&
    location.pathname !== '/join' &&
    location.pathname !== '/joininfo' &&
    location.pathname !== '/joincomplete' &&
    location.pathname !== '/error' &&
    location.pathname !== '/update';

  useEffect(() => {
    const handleScroll = () => {
      const yPos = window.scrollY;

      setIsVisible(yPos > 320);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClickscrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  return (
    <ConfigProvider theme={theme}>
      <Wrapper>
        {links && <Nav />}

        <Container
          $isNav={links}
          $isMain={location.pathname === '/'}
          $isDownload={location.pathname !== '/download'}
        >
          <MainRouter />
        </Container>
        {links && (
          <FooterWrapper>
            <Footer />
          </FooterWrapper>
        )}
        <GlobalModal />
        {isVisible && <ScrollToTopButton onClick={handleClickscrollToTop} />}
      </Wrapper>
    </ConfigProvider>
  );
};

export default App;

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
`;

const Container = styled.div<{ $isNav: boolean; $isDownload: boolean; $isMain: boolean }>`
  // max-width: ${(props) => (props.$isDownload ? '1920px' : '100%')};
  width: 100%;
  min-width: ${(props) => (props.$isMain ? '1440px' : '1280px')};
  margin: ${(props) => (props.$isNav ? '112px' : '0px')} auto 0;
`;

const FooterWrapper = styled.footer`
  width: 100%;
  background: ${color.navyLight};
  margin: 138px auto 0;
`;
